import type { ValidationIssue } from "../types/SemanticTypes";
import { wordService } from "../services/wordService";

export async function validateTables(): Promise<ValidationIssue[]> {
  const tables = await wordService.readTables();
  const controls = await wordService.readSemanticControls();
  const issues: ValidationIssue[] = [];
  const captions = controls.filter((item) => item.metadata.type === "table_caption");
  const tableControls = controls.filter((item) => item.metadata.type === "table");

  tables.forEach((table) => {
    if (table.rows.length === 0) return;
    const widths = new Set(table.rows.map((row) => row.length));
    if (widths.size > 1 || !table.isUniform) issues.push(issue("merged-cells", "error", "Possible merged cells detected. Tables must not use merged cells.", `Table ${table.index}`, { tableIndex: table.index }));
    if (table.nestingLevel > 1) issues.push(issue("nested-table", "error", "Nested tables are not allowed.", `Table ${table.index}`, { tableIndex: table.index }));
    if (table.rows[0].every((cell) => cell.trim().length === 0)) {
      issues.push(issue("empty-header-row", "error", "First row must be a non-empty header row.", `Table ${table.index}`, { tableIndex: table.index }));
    }
    if (!tableControls[table.index - 1]) {
      issues.push(issue("untagged-table", "warning", "Native Word table is not tagged as a semantic table.", `Table ${table.index}`, { tableIndex: table.index }));
    }
    if (!captions[table.index - 1]) {
      issues.push(issue("missing-table-caption", "error", "Table caption is required.", `Table ${table.index}`, { tableIndex: table.index }));
    }
  });

  const captionTexts = captions.map((caption) => caption.text);
  const duplicateCaptions = captionTexts.filter((caption, index) => captionTexts.indexOf(caption) !== index);
  duplicateCaptions.forEach((caption) =>
    issues.push(issue("duplicate-table-numbering", "warning", "Duplicate table numbering or caption detected.", undefined, { caption }))
  );

  return issues;
}

function issue(code: string, severity: ValidationIssue["severity"], message: string, location?: string, metadata?: ValidationIssue["metadata"]): ValidationIssue {
  return { code, severity, message, location, metadata };
}
